import { render } from "./SessionAlert.vue?vue&type=template&id=33e54779"
import script from "./SessionAlert.vue?vue&type=script&lang=js"
export * from "./SessionAlert.vue?vue&type=script&lang=js"

import "./SessionAlert.vue?vue&type=style&index=0&id=33e54779&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__